(() => {
  'use strict';
  const init = () => {
    const root = document.querySelector('[data-ccv1-cart-offers]');
    const service = window.Ccv1Cart;
    const model = window.Ccv1CartOfferModel;
    if (!root || !service || !model) return;
    let products;
    try { products = JSON.parse(root.querySelector('[data-ccv1-offer-catalog]').textContent); }
    catch (_error) { return; }
    const el = (name) => root.querySelector(`[data-ccv1-offer-${name}]`);
    const add = root.querySelector('[data-ccv1-cart-offer-add]');
    const select = el('select');
    let preferSmaller = false;
    let selectedId = 0;
    let dismissed = false;
    let completed = false;
    let shown = false;
    let latestCart = service.snapshot();
    let currentOffer = null;
    let clickedOffer = null;
    const track = (event, extra = {}, trackedOffer = currentOffer) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, offer_source: 'cart', variant_id: trackedOffer?.product.id,
        offer_type: trackedOffer?.isDownsell ? 'smaller_add_on' : 'next_flavor',
        value: (trackedOffer?.incrementalPrice || 0) / 100, currency: latestCart?.currency || 'USD', ...extra });
    };
    const render = (cart) => {
      if (!cart) return;
      latestCart = cart;
      if (dismissed || !cart.item_count) { root.hidden = true; return; }
      if (completed) return;
      const pricing = service.pricing(cart);
      let offer = model.build({ cart, products, pricing, preferSmaller });
      if (!offer) { root.hidden = true; return; }
      const primaryPrice = model.build({ cart, products, pricing })?.incrementalPrice || 0;
      const availableChoices = products.filter((product) => product.available && product.kind === offer.product.kind
        && (offer.product.kind !== 'small' || !offer.isDownsell || product.price < primaryPrice));
      const selected = availableChoices.find((product) => product.id === selectedId);
      if (selected) {
        const selectedOffer = model.build({ cart, products: [selected], pricing });
        if (selectedOffer) offer = { ...selectedOffer, canDownsell: offer.canDownsell, isDownsell: offer.isDownsell };
      }
      currentOffer = offer;
      const product = offer.product;
      root.hidden = false;
      el('eyebrow').textContent = offer.isTierOffer ? 'Your next 2 bags cost less' : 'A little extra?';
      el('title').textContent = offer.isDownsell || product.kind === 'small' ? 'Small add. Big flavor.' : 'One more flavor?';
      el('image').src = product.image;
      el('image').alt = `${product.title}, 2-bag pack`;
      el('link').href = product.url;
      select.replaceChildren(...availableChoices.map((choice) => {
        const option = document.createElement('option');
        option.value = String(choice.id);
        option.textContent = choice.title;
        option.selected = choice.id === product.id;
        return option;
      }));
      el('size').textContent = product.kind === 'bites' ? '2 extra-large 8 oz bags' : '2 bags · one flavor';
      el('price').textContent = service.formatMoney(offer.incrementalPrice);
      el('value').hidden = !offer.saving;
      el('value').textContent = service.formatMoney(product.price);
      el('saving').hidden = !offer.saving;
      el('saving').textContent = `Save ${service.formatMoney(offer.saving)} on this add`;
      const shippingThreshold = Number(document.querySelector('[data-ccv1-cart-top]')?.dataset.shippingThreshold || 0);
      const unlocksShipping = shippingThreshold > cart.total_price
        && cart.total_price + offer.incrementalPrice >= shippingThreshold;
      el('explanation').textContent = unlocksShipping ? 'This add unlocks free U.S. shipping.' : (offer.isTierOffer ? 'Any Bites flavor. Same deal.' : '');
      el('explanation').hidden = !offer.isTierOffer && !unlocksShipping;
      Object.assign(add.dataset, {
        ccv1Bundle: `${product.id}:1`, ccv1BundleTitle: product.title,
        ccv1OfferFamily: 'individual', ccv1TotalBags: '2', ccv1OfferSource: offer.isDownsell ? 'cart_downsell' : 'cart_upsell',
        ccv1ProgressiveEligible: String(product.kind === 'bites'), ccv1Available: 'true',
        ccv1DiscountCode: offer.discountCode, ccv1TierTargetQuantity: String(offer.targetPairs),
        ccv1CartOfferPrice: String(offer.incrementalPrice), ccv1CartOfferBasePrice: String(product.price),
        ccv1IdleLabel: 'Add 2 bags',
      });
      add.disabled = false;
      if (add.getAttribute('aria-busy') !== 'true') add.querySelector('[data-ccv1-button-label]').textContent = 'Add 2 bags';
      el('smaller').hidden = !offer.canDownsell || preferSmaller;
      el('back').hidden = !preferSmaller;
      if (!shown) { shown = true; track('cc_cart_offer_view'); }
    };
    select.addEventListener('change', () => { selectedId = Number(select.value); render(latestCart); });
    el('smaller').addEventListener('click', () => {
      preferSmaller = true; selectedId = 0; render(latestCart); track('cc_cart_downsell_view');
    });
    el('back').addEventListener('click', () => { preferSmaller = false; selectedId = 0; render(latestCart); });
    root.querySelectorAll('[data-ccv1-offer-dismiss]').forEach((button) => button.addEventListener('click', () => {
      track('cc_cart_offer_dismiss'); dismissed = true; root.hidden = true;
      document.querySelector('[name="checkout"]')?.focus();
    }));
    add.addEventListener('click', () => { if (!add.disabled) { clickedOffer = currentOffer; track('cc_cart_offer_click'); } });
    window.addEventListener('ccv1:cart-state', (event) => render(event.detail.cart));
    window.addEventListener('ccv1:cart-offer-added', (event) => {
      track('cc_cart_offer_added', {}, clickedOffer); completed = true;
      el('content').hidden = true;
      el('success').hidden = false;
      el('success').textContent = `${event.detail.title} added. Good choice.`;
      document.querySelector('[name="checkout"]')?.focus();
    });
    render(latestCart);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
